import startOfToday from "date-fns/startOfToday";
import { consts as uploaderConsts } from "uploader";
import { asAbsolute } from "root/routes/utils";

export const getInternalPath = (page?: string) => {
	return page ? asAbsolute(uploaderConsts.SOURCES.ISTOCK, page) : asAbsolute(uploaderConsts.SOURCES.ISTOCK);
};

export const getSelectedItemByValue = (value: string, options: { label: string, value: string }): Object => options.find((item) => item.value === value);


export const secondsToMinutes = (sec) => {
	return `${new Date(sec * 1000).toISOString().substr(14, 5)}${sec === 120 ? "+" : ""}`;
};

export const today = () => startOfToday();
